import type {HTMLChakraProps} from '@chakra-ui/react';
import {cx} from '@chakra-ui/shared-utils';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {ChakraSpan} from '@linx-security/ui/utils/chakra-elements';

import {isFontAwesomeIcon} from '../../utils/is-fa';

import {getStatusIcon, useToastContext, useToastStyles} from './context';

export interface AlertIconProps extends HTMLChakraProps<'span'> {}

export const ToastIcon = (props: AlertIconProps) => {
  const {status} = useToastContext();
  const BaseIcon = getStatusIcon(status);
  const styles = useToastStyles();

  const renderIcon = () => {
    if (isFontAwesomeIcon(BaseIcon)) {
      return <FontAwesomeIcon icon={BaseIcon} style={{width: `100%`, height: `100%`}} />;
    }

    return BaseIcon ? <BaseIcon /> : null;
  };

  return (
    <ChakraSpan
      display={`inherit`}
      data-status={status}
      {...props}
      __css={styles.icon}
      className={cx(`chakra-toast__icon`, props.className)}>
      {props.children || renderIcon()}
    </ChakraSpan>
  );
};

ToastIcon.displayName = `ToastIcon`;
